import { TextField } from '@mui/material';
import React from 'react';

interface NameInputProps {
  value: string;
  onChange: (value: string) => void;
}

export const NameInput: React.FC<NameInputProps> = ({ value, onChange }) => {
  return (
    <TextField
      label="Nom"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      size="small"
      fullWidth
    />
  );
};
